// Shared date/time formatting utilities.
// SQLite stores CURRENT_TIMESTAMP as UTC without timezone marker (e.g. "2026-04-19 05:30:00").
// Parsing without a timezone marker is browser-implementation-defined — we always append 'Z'
// so JS correctly interprets the value as UTC and converts to the user's local timezone.

const _parse = (v) => {
  if (!v) return null;
  const s = String(v).trim();
  // Already has timezone info — parse as-is
  if (s.includes('Z') || /[+-]\d{2}:\d{2}$/.test(s)) return new Date(s);
  // ISO datetime without timezone (e.g. "2026-04-19T05:30:00") — treat as UTC
  if (s.includes('T')) return new Date(s + 'Z');
  // SQLite space-separated datetime (e.g. "2026-04-19 05:30:00") — treat as UTC
  if (s.includes(' ') && s.length > 10) return new Date(s.replace(' ', 'T') + 'Z');
  // Date-only strings ("2026-04-19") — spec says these are UTC midnight, no change needed
  return new Date(s);
};

/** Format a date value as MM-DD-YYYY. Returns '—' for empty/invalid. */
export const fmtDate = (v) => {
  if (!v) return '—';
  const d = _parse(v);
  if (!d || isNaN(d)) return String(v);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${mm}-${dd}-${yyyy}`;
};

/** Format a datetime value as MM-DD-YYYY h:MM AM/PM. Returns '—' for empty/invalid. */
export const fmtDateTime = (v) => {
  if (!v) return '—';
  const d = _parse(v);
  if (!d || isNaN(d)) return String(v);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();
  let h = d.getHours();
  const min = String(d.getMinutes()).padStart(2, '0');
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${mm}-${dd}-${yyyy} ${h}:${min} ${ampm}`;
};
